import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class ContinualImprovementProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'continualImprovement'}
            title={'PROCEDURE P15.0 CONTINUAL IMPROVEMENT'}
            exportTitle={'<h2>Procedure P15.0 Continual Improvement</h2>'}
            exportFileName={'continual_improvement.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (ContinualImprovementProcedure);
